import { notification } from 'antd5';
import type { NotificationInstance } from 'antd5/es/notification/interface';
import React, { createContext, useContext, useMemo } from 'react';

const NotificationContext = createContext<NotificationInstance | null>(null);

export const NotificationContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [api, contextHolder] = notification.useNotification();

  const contextValue = useMemo(() => api, [api]);

  return (
    <NotificationContext.Provider value={contextValue}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = (): NotificationInstance => {
  const context = useContext(NotificationContext);
  if (!context) {
    console.error(
      'useGlobalNotification must be used within a NotificationProvider; notification will not be rendered'
    );
    const NOOP = () => {};
    return {
      success: NOOP,
      error: NOOP,
      info: NOOP,
      warning: NOOP,
      open: NOOP,
      destroy: NOOP,
    };
  }
  return context;
};
